import { Note } from '@card-software/library';
import { AuditTrail } from '@card-software/nexus-models';
import { Fabric } from '../item/fabric';
import { Business } from '../finance/business';

export interface WorkOrder extends AuditTrail {
  actualShipmentDate: string;
  billingAddressCode: number;
  billingTo?: Business;
  billingToReference: string;
  brand: Business;
  brandReference: string;
  customer: Business;
  customerProductOrders: CustomerProductOrders[];
  customerReference: string;
  estimatedDatesPlanning?: EstimatedDatesPlanning;
  estimatedShipmentDate: string;
  fabrics: WorkOrderFabric[];
  id: string;
  negotiatiedLeadTimeInWeeks: number;
  notes: Note[];
  orderNumber: string;
  orderReceivedDate: string;
  orderType: number;
  paymentTermsClientCode: string;
  planningEstimatedYW: YearWeek;
  programReference: string;
  promisedShipmentDate?: Date | null;
  parentBulkWorkOrder?: string;
  shipmentType: number;
  shippingAddressCode: number;
  shippingTo?: Business;
  shippingToReference: string;
  specificWorkOrderGreige: string;
  specificWorkOrderGreigeReference: string;
  status: number;
  uom: number;
  workOrderTerm: number;
  yarnOrigin?: number;
}

export interface WorkOrderFabric {
  id: string;
  fabricCode: string;
  clientRequestedFabricLabelCode?: string;
  fabric: Fabric;
  packingType: number;
  quantityInUOM: number;
  quantityInPounds: number;
  unitPrice?: number;
  garmetPart: number;
  productOrderNumber?: string;
  aliasReference?: string;
  garmetDetails?: GarmentDetails[];
  yarnCertificationDetails?: YarnCertificationDetails[];
}

export interface YarnCertificationDetails {
  yarnCode: string;
  certificationReferences: string[];
}

export interface GarmentDetails {
  colorReference: string;
  quantity: number;
  quantityInPounds: number;
  productOrderNumber?: string;
  unitPrice: number;
}

export interface CustomerProductOrders {
  productOrderNumber: string;
  clientOrderReference: string;
  dateReceived: string;
}

export interface YearWeek {
  year: number;
  week: number;
}

export interface WorkOrderSearchCommand {
  orderNumber?: string;
  customerReference?: string;
  brandReference?: string;
  orderType?: number;
  customerProductOrder?: string;
  statuses?: number[];
  // Work-order creation date range. Mirrors CreatedFrom/CreatedTo added to the
  // backend Sierra.Order.Models.Commands.WorkOrderSearch DTO (PBI #4415).
  createdFrom?: Date;
  createdTo?: Date;
}

export interface EstimatedDatesPlanning {
  yarnLatestReceptionDate?: Date | null;
  knittingLatestStartDate?: Date | null;
  knittingEstimatedEndDate?: Date | null;
  dyeingLatestStartDate?: Date | null;
  dyeingEstimatedEndDate?: Date | null;
  finishingLatestStartDate?: Date | null;
  finishingEstimatedEndDate?: Date | null;
}

export enum WorkOrderType {
  Sample,
  Bulk,
  GreigeStockForDyeing,
  ShortFall,
  Linked,
  BGrade,
  GreigeOnly,
}

export enum WorkOrderTerm {
  CommissionKnitting,
  FullKnitting,
  Dyeing,
  FullPackage,
  CommissionKnittingAndDyeing,
  BGrade,
}

export enum WorkOrderStatus {
  Draft,
  Submitted,
  Approved,
  InPlanning,
  InProduction,
  Packaged,
  Shipped,
  Voided,
}

export enum PackingType {
  Rolling,
  Folding,
}
